import axios from "../utils/axios";

/**
 * Get Customer Profile
 * @returns {Promise} Profile data
 */
export const getProfile = async () => {
    try {
        const { data } = await axios.get('/profile');
        return data;
    } catch (error) {
        console.error("🚀 ~ getProfile ~ error:", error);
        throw error;
    }
};

/**
 * Update Customer Profile
 * @param {FormData|Object} profileData - Profile data to update
 * @returns {Promise} Updated profile data
 */
export const updateProfile = async (profileData) => {
    try {
        const { data } = await axios.put('/profile', profileData);
        return data;
    } catch (error) {
        console.error("🚀 ~ updateProfile ~ error:", error);
        throw error;
    }
};

/**
 * Update Password
 * @param {Object} passwordData - { current_password, password, password_confirmation }
 * @returns {Promise} 
 */
export const updatePassword = async (passwordData) => {
    try {
        const { data } = await axios.put('/profile/password', passwordData);
        return data;
    } catch (error) {
        console.error("🚀 ~ updatePassword ~ error:", error);
        throw error;
    }
};
